var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSlider1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5306 13.5307L14.0306 18.0307C13.8897 18.1716 13.6986 18.2508 13.4994 18.2508C13.3001 18.2508 13.109 18.1716 12.9681 18.0307C12.8272 17.8898 12.7481 17.6987 12.7481 17.4995C12.7481 17.3002 12.8272 17.1091 12.9681 16.9682L16.1875 13.7501H7C6.80109 13.7501 6.61032 13.6711 6.46967 13.5304C6.32902 13.3898 6.25 13.199 6.25 13.0001C6.25 12.8012 6.32902 12.6104 6.46967 12.4698C6.61032 12.3291 6.80109 12.2501 7 12.2501H16.1875L12.9694 9.03011C12.8285 8.88921 12.7493 8.69812 12.7493 8.49886C12.7493 8.2996 12.8285 8.10851 12.9694 7.96761C13.1103 7.82671 13.3014 7.74756 13.5006 7.74756C13.6999 7.74756 13.891 7.82671 14.0319 7.96761L18.5319 12.4676C18.6018 12.5374 18.6573 12.6203 18.6951 12.7115C18.7329 12.8028 18.7523 12.9006 18.7522 12.9994C18.752 13.0982 18.7324 13.196 18.6944 13.2872C18.6564 13.3784 18.6007 13.4611 18.5306 13.5307Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSlider1);
export default __webpack_public_path__ + "static/media/arrow-slider-1.c0cae6351290e20004dca37a972541e3.svg";
export { ForwardRef as ReactComponent };